<template>
  <v-container fluid class="bg-image">
    <v-row>
      <v-btn @click="$router.push('/welcome')" color="white" class="text-capitalize" text>
        <v-icon>mdi-chevron-left</v-icon>{{$t('go_back')}}
      </v-btn>
      <v-btn text color="white" @click="changeLang('en')">EN</v-btn>
      <p class="my-0 mt-1 white--text">|</p>
      <v-btn text color="white" @click="changeLang('fr')">FR</v-btn>
    </v-row>
    <v-row class="mx-3"></v-row>
    <v-layout justify-center>
      <v-flex xs12 sm8 md5 class="text-center mx-2">
        <v-img
          class="mt-5"
          :src="imageLogoUrlWhite"
          :max-height="imageHeight"
          contain
          aspect-ratio="1.7"
        ></v-img>
        <v-form ref="login-form">
          <v-row justify-lg="center">
            <v-col cols="12" md="8" class="ma-0 pa-0">
              <v-text-field
                prepend-inner-icon="mdi-account"
                :rules="[email($t('email_must_be_valid'))]"
                v-model="user.email"
                flat
                height="40px"
                solo
                :label="$t('email')"
                @keyup.enter="login"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8" class="ma-0 pa-0">
              <v-text-field
                prepend-inner-icon="mdi-lock"
                :rules="[required($t('password_required'))]"
                v-model="user.password"
                flat
                solo
                :label="$t('password')"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                @keyup.enter="login"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8" class="ma-0 pa-0 text-left">
              <p class="caption font-weight-regular pt-1 white--text">
                <a
                  @click.stop.prevent="$router.push('/forgot-password')"
                  class="white--text"
                >{{$t('forgot_password')}}?</a>
              </p>
            </v-col>
          </v-row>
        </v-form>
        <v-row justify-lg="center">
          <v-col cols="12" md="8" class="ma-0 pa-0">
            <p class="caption font-weight-regular ma-0 pa-0 white--text">
              {{$t('dont_have_account')}}
              <a
                @click.stop.prevent="$router.push('/register')"
                class="white--text"
              >{{$t('sign_up')}}</a>
            </p>
          </v-col>
          <v-col cols="12" md="8" class="ma-0 pa-0 pt-7">
            <v-btn @click="login" color="primary" class="px-10">{{$t('login')}}</v-btn>
          </v-col>
        </v-row>
        <br />
        <br />
        <app-footer />
      </v-flex>
    </v-layout>
    <!-- <br v-if="this.$vuetify.breakpoint.smAndDown" />
    <br v-if="this.$vuetify.breakpoint.smAndDown" />
    <br v-if="this.$vuetify.breakpoint.smAndDown" />
    <br v-if="this.$vuetify.breakpoint.smAndDown" />-->
  </v-container>
</template>

<script>
import { CONSUMERS_API } from '@/clients/consumers.api'
import { Validations } from '@/utils/validations'
import { mapActions, mapMutations } from 'vuex'
export default {
  components: {
    AppFooter: () => import('@/components/Footer.vue')
  },
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      showPassword: false
    }
  },
  methods: {
    ...mapMutations({
      setAgeVerificationStatus: 'Auth/SET_AGE_VERIFICATION_STATUS'
    }),
    ...Validations,
    ...mapActions({
      va_loginWithEmail: 'Auth/loginWithEmail'
    }),
    async login () {
      if (!this.$refs['login-form'].validate()) {
        await this.$goToError
        return
      }
      this.$spinner()
      try {
        await this.va_loginWithEmail(this.user)
      } catch (e) {
        console.log(e.error)
        this.$spinner()
        return this.$snackbar({ text: Array.isArray(e.error.payload) ? e.error.payload.join(' | ') : e.error.msg, color: 'error', timeout: 7000 })
      }
      this.$spinner()
      this.setAgeVerificationStatus(true)
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect)
      } else {
        this.$router.push('/choose-regions')
      }
    }
  },
  computed: {
    imageHeight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '225px'
        case 'sm': return '250px'
        case 'md': return '225px'
        case 'lg': return '250px'
        case 'xl': return '250px'
        default: return '150px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}

.bg-image {
  background: linear-gradient(
      0deg,
      rgba(2, 16, 48, 0.25),
      rgba(2, 16, 48, 0.25)
    ),
    url("../assets/images/Stock/background-image.jpg");
  /* Background image is centered vertically and horizontally at all times */
  background-position: center center;

  /* Background image doesn't tile */
  background-repeat: no-repeat;

  /* Background image is fixed in the viewport so that it doesn't move when
     the content's height is greater than the image's height */
  background-attachment: fixed;

  /* This is what makes the background image rescale based
     on the container's size */
  background-size: cover;

  /* Set a background color that will be displayed
     while the background image is loading */
}

.forget-password-card {
  background: rgba($color: #f0f0f0, $alpha: 1);
}
</style>
